<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="x-button" @click="$emit('cancel')">&times;</div>
          <div class="modal-header">
            <slot name="header" v-if="mode.add">Add an item</slot>
          </div>
          <div class="modal-body">
            <slot name="body" v-if="checkType(currentWidget.type, 'article') && (mode.add || currentWidget.type == 'hero')">
              <input
                class="modal-input"
                v-model="searchTerm"
                v-on:input="searchForTerm"
                placeholder="Search Mamamia..."
              >

              <div
                v-if="searchResults"
                id="searchResults"
                style="font-size:10px;color:black; max-height:45vh;overflow:auto;margin-bottom:20px;"
              >
                <div
                  :class="'result flex-row ' + (selectedItem == result ? 'selectedItem' : '')"
                  @click="selectedItem = result"
                  v-on:click="onSelected"
                  v-for="(result, key) in searchResults"
                  v-bind:key="key"
                >
                  <div>
                    <img :src="result.image" style="width:100px;">
                  </div>
                  <div class="flex1">
                    <h2 v-html="result.algoliaTitle"></h2>
                    <p v-html="result.algoliaContent"></p>
                  </div>
                </div>
              </div>
            </slot>
            <slot name="body" v-if="checkType(currentWidget.type, 'podcast')">
              <select v-model="podcastPlaylist">
                <option
                  v-for="(item,key) in podcasts"
                  :value="{slug: item['.key'], title: item.title}"
                  :key="key"
                >{{ item.title }}</option>
              </select>
            </slot>
            <slot name="body" v-if="checkType(currentWidget.type, 'video')">
              <select v-model="videoPlaylist">
                <option
                  v-for="(item,key) in videos"
                  :value="{slug: item['.key'], title: item.title}"
                  :key="key"
                >{{ item.title }}</option>
              </select>
            </slot>
            <slot name="body" v-if="checkType(currentWidget.type,'article') && currentWidget.type !== 'hero'">
              <modal-multi-article
                :selectedItem="selectedItem"
                :currentWidget="currentWidget"
                :newWidgetOrder="newWidgetOrder"
                @setWidgetData="$emit('setWidgetData',$event)" 
                @reorder="reorder"
                :mode="mode"
                :storage="storage"
              />
            </slot>
            <slot name="body" v-if="checkType(currentWidget.type,'author') && currentWidget.type !== 'hero'">
              <modal-multi-author
                :selectedItem="selectedItem"
                :currentWidget="currentWidget"
                :newWidgetOrder="newWidgetOrder"
                @setWidgetData="$emit('setWidgetData',$event)" 
                @reorder="reorder"
                :mode="mode"
                :storage="storage"
              />
            </slot>
            <slot name="body" v-if="checkType(currentWidget.type,'article') && currentWidget.type === 'hero'">
              <modal-single-article
                :storage="storage"
                :selectedItem="selectedItem"
                :previewImage="previewImage"
                v-model="previewImage"
                :mode="mode"
              />
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('cancel')">Cancel</button>
              <button
                class="modal-default-button"
                @click="emitArticle"
                v-if="checkType(currentWidget.type, 'article')"
              >{{mode.edit ? 'Save' : 'Create'}}</button>
              <button
                class="modal-default-button"
                @click="updateAuthors"
                v-if="checkType(currentWidget.type, 'author')"
              >Save</button>
              <button
                class="modal-default-button"
                @click="$emit('create', podcastPlaylist)"
                v-if="checkType(currentWidget.type, 'podcast')"
              >Create</button>
              <button
                class="modal-default-button"
                @click="$emit('create', videoPlaylist)"
                v-if="checkType(currentWidget.type, 'video')"
              >Create</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import firebase from "firebase";

import ModalMultiAuthor from "./ModalMultiAuthor";
import ModalMultiArticle from "./ModalMultiArticle";
import ModalSingleArticle from "./ModalSingleArticle";
export default {
  name: "modal",
  props: ["podcasts", "storage", "videos", "currentWidget", "mode"],
  components: {
    ModalMultiAuthor,
    ModalMultiArticle,
    ModalSingleArticle
  },
  data: function() {
    return {
      newWidgetOrder: "",
      searchTerm: "",
      overrideImage: false,
      previewImage: "",
      searchResults: [],
      selectedItem: {
        slug: "",
        title: "",
        image: "",
        socialImage: "",
        created: "",
        authorName: "",
        authorImage: "",
        overrideImage: ""
      },
      videoPlaylist: {
        id: "",
        title: "",
        playlist: []
      },
      videoPlaylistPreview: [],
      podcastPlaylist: {
        id: "",
        title: "",
        url: "",
        slug: ""
      },
      podcastPlaylistPreview: [],
      uploaderKey: 1
    };
  },
  mounted: function() {
    var client = algoliasearch(
      "U5GL740LVM",
      "ee79df2ed46df0e29f0a0e05d9d2466f"
    );
    this.algolia = client.initIndex("posts");
    if(this.currentWidget.type == "hero" && this.currentWidget.items) {
      this.selectedItem = Object.assign({},this.currentWidget.items[0]);
    }
},
  methods: {
    updateAuthors: function() {
      if(this.newWidgetOrder)
        this.$emit('update', this.newWidgetOrder);
      else this.$emit('update', this.currentWidget.items);
    },
    reorder: function(e) {
      this.newWidgetOrder = e;
      console.log(this.newWidgetOrder);
    },
    onSelected: function(e) {
      this.searchResults = 0;
      this.searchTerm = "";
      this.previewImage = this.selectedItem.image;
    },
    emitArticle: function() {
      let obj = {
        postid: this.selectedItem.postid,
        title: this.selectedItem.title,
        image: this.selectedItem.image
      };
      if (this.selectedItem.overrideImage) {
        obj.image = this.selectedItem.overrideImage;
      }
      if (this.newWidgetOrder.length > 0) {
        obj.reorder = this.newWidgetOrder;
      }
      console.log(obj);
      if (this.mode.edit && this.newWidgetOrder.length < 1) {
        this.$emit("edit", obj);
      } else {
        this.$emit("create", obj);
      }
    },
    searchForTerm: function() {
      var query = this.searchTerm;
      this.algolia
        .search({
          query
        })
        .then(responses => {
          this.searchResults = [];
          var searchResults = [];
          console.log(responses);
          responses.hits.forEach(hit => {
            if (searchResults.length < 5) {
              searchResults.push({
                postid: hit.objectID,
                slug: hit.slug,
                image: hit.image,
                title: hit.title,
                algoliaTitle: hit._highlightResult.title.value,
                content: hit._snippetResult.content.value
              });
            }
          });

          // To avoid DOM redraws repeatedly
          // Is this needed? Is Vue smart enough to not redraw when lots of pushes happen?
          this.searchResults = searchResults;
        });
    },
    checkType: function(type, check) {
      const podcastType = ["menu-podcasts", "listen", "all-podcasts", "podcast-carousel"];
      const authorType = ['author-carousel'];
      const articleType = [
        "curatedArticles",
        "hero",
        "top-stories",
        "vertical-article-block",
        "three-row-column",
        "grid-three",
        "grid-four",
        "horizontal-scroller"
      ];
      const videoType = ["menu-video-playlists", "all-video-topics"];
      // Maybe move consts to data function
      if(check == "author" && authorType.includes(type)) {
        return true;
      } else if (check == "article" && articleType.includes(type)) {
        return true;
      } else if (check == "podcast" && podcastType.includes(type)) {
        return true;
      } else if (check == "video" && videoType.includes(type)) {
        return true;
      }
      return false;
    },
    restrictCharacters: function(string) {
      if (string.length > 30) return string.substring(0, 30) + "...";
      return string;
    }
  },
};
</script>

<style>
.result em {
  background-color: #ccc;
  color: black;
}
</style>

<style scoped>
.result {
  cursor: pointer;
  margin: 5px 0;
}
.result:hover {
  background-color: #eee;
}
.result.selectedItem {
  background-color: #8ebab5;
}

.flex-row {
  display: flex;
}
.x-button {
  margin-left: auto;
  cursor: pointer;
  font-size: 30px;
}
input {
  display: block;
  margin-bottom: 20px;
}
.modal-mask {
  overflow-y: scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
img {
  max-width: 300px;
}
.flex1 {
  margin-left: 5px;
}
.flex1 h2 {
  margin: 0;
  border: none;
}
.flex1 p {
  margin: 3px 0 3px 0;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 95vh;
  color: black;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  overflow: auto;
}

/* .modal-default-button {

} */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding: 5px;
}
.modal-footer button {
  margin: 0 5px;
  height: 30px;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
  .video-scroll-button {
    display: none !important;
  }
}
.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;

  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.card {
  border: 1px solid white;
  width: 150px;
  flex: 0 0 auto;
  margin-right: 3px;
}
.card img {
  width: 150px;
}

.video-block {
  position: relative;
  margin-left: 20px;
  max-width: 300px;
}

input {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// ModalCreate.vue?0f3db31c